@file:OptIn(InternalResourceApi::class)

package animations.core.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/animations.core.ui.generated.resources/"

@delegate:ResourceContentHash(2_136_119_855)
internal val Res.font.syne_bold: FontResource by lazy {
      FontResource("font:syne_bold", setOf(
        ResourceItem(setOf(), "${MD}font/syne_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_331_934_924)
internal val Res.font.syne_extra_bold: FontResource by lazy {
      FontResource("font:syne_extra_bold", setOf(
        ResourceItem(setOf(), "${MD}font/syne_extra_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(736_140_142)
internal val Res.font.syne_medium: FontResource by lazy {
      FontResource("font:syne_medium", setOf(
        ResourceItem(setOf(), "${MD}font/syne_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-785_994_484)
internal val Res.font.syne_regular: FontResource by lazy {
      FontResource("font:syne_regular", setOf(
        ResourceItem(setOf(), "${MD}font/syne_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-35_512_535)
internal val Res.font.syne_semi_bold: FontResource by lazy {
      FontResource("font:syne_semi_bold", setOf(
        ResourceItem(setOf(), "${MD}font/syne_semi_bold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("syne_bold", Res.font.syne_bold)
  map.put("syne_extra_bold", Res.font.syne_extra_bold)
  map.put("syne_medium", Res.font.syne_medium)
  map.put("syne_regular", Res.font.syne_regular)
  map.put("syne_semi_bold", Res.font.syne_semi_bold)
}
